"use client";

import React, { useContext, useEffect } from "react";
import { ReactSVG } from "react-svg";

import { Banner } from "@/components/Banner";
import { Typography } from "@/components/Typography";
import { QRPreviewData } from "@/components/QRPreview";
import { GridSelectorLanding } from "./GridSelectorLanding/GridSelectorLanding";
import { PreviewProps, previewLandingItem } from "@/data/types/landingsSEM";
import { QRType, QRTypeName } from "@/types/qr";
import { setNewQRData } from "@/utils/qrEditorHelper";
import { QREditorContextProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";
import { useRouter } from "next/navigation";
import { BannerWrapperSize } from "../Banner/types";
import { AmplitudeContext } from "@/contexts/AmplitudeContext/AmplitudeContext";

import "./styles.scss";
export const GridLandingModule = ({
  wrapperSize,
  data,
}: {
  data: PreviewProps;
  wrapperSize: BannerWrapperSize;
}) => {
  const { setSource } = useContext(AmplitudeContext);
  const { subtitle, title, titleRemarked, backgroundColor, customClass } = data;
  const router = useRouter();
  const qrEditorContext = useContext<QREditorContextProps<any>>(QREditorContext);

  useEffect(() => {
    setNewQRData(qrEditorContext, data.mainItem.id, data.mainItem.title);
  }, []);

  const hoverChangeQRType = (type: QRType, name: QRTypeName) => {
    setNewQRData(qrEditorContext, type, name);
  };

  const onClickQRselect = (item: previewLandingItem) => {
    setSource("landing_sem");
    router.push(item.ctaLink);
  };

  return (
    <Banner
      big
      light
      customBgColor={backgroundColor}
      wrapperSize={wrapperSize}
      customClass={`banner-preview ${customClass}`}>
      <div className="module-container">
        <div className="module-container__grid">
          <div className="module-container__header">
            {titleRemarked ? (
              <Typography
                Tag={"h2"}
                spacing={4}>
                {title} <span className="color-primary">{titleRemarked}</span>
              </Typography>
            ) : (
              <Typography
                Tag={"h2"}
                spacing={4}>
                <span dangerouslySetInnerHTML={{ __html: title }}></span>
              </Typography>
            )}

            <ReactSVG
              src={`/svg/landing-arrow.svg`}
              className="arrow-svg"
              role="img"
              aria-label="arrow-svg"
            />
            <Typography
              Tag={"p"}
              size="l">
              {subtitle}
            </Typography>
          </div>
          <GridSelectorLanding
            data={data}
            onHoverChangeQRType={(id, title) => hoverChangeQRType(id, title)}
            onClickQRselect={(item) => onClickQRselect(item)}
          />
        </div>
        <div className="module-container__preview">
          <QRPreviewData
            data={qrEditorContext?.qrData}
            previewTranslations={"previewTranslations"}
            isQRInit={true}
            isQRActivated={true}
            language={"en"}
          />
        </div>
      </div>
    </Banner>
  );
};
